import { colorGetter } from '../../utils/theme';
import { Notification } from './Notification';
import { invertedColorMap, colorMap } from './tokens';
/**
 * Check this figma link for more details regarding the theming
 * https://www.figma.com/file/KCJhOzhpVah4COL8rlZJxv/(WIP)-00.-Tractor---Phone?node-id=9%3A6
 */

export var makeNotificationVariant = function makeNotificationVariant(_ref) {
  var variant = _ref.variant,
      inverted = _ref.inverted,
      theme = _ref.theme;
  var map = inverted ? invertedColorMap : colorMap;
  var _map$variant = map[variant],
      background = _map$variant.background,
      heading = _map$variant.heading,
      icon = _map$variant.icon,
      paragraph = _map$variant.paragraph,
      button = _map$variant.button;
  var getColor = colorGetter(theme);
  return "\n    background-color: " + getColor(background) + ";\n\n    " + Notification.Heading + " {\n      color: " + getColor(heading) + ";\n    }\n\n    " + Notification.Paragraph + " {\n      color: " + getColor(paragraph) + ";\n    }\n\n    " + Notification.Icon + " svg {\n      color: " + getColor(icon) + "\n    }\n\n    " + Notification.ButtonGroup + " {\n      svg {\n        color: " + getColor(button) + "\n      }\n    }\n   ";
};